import { render, staticRenderFns } from "./PackageBuy.vue?vue&type=template&id=0730c276&scoped=true"
import script from "./PackageBuy.vue?vue&type=script&lang=js"
export * from "./PackageBuy.vue?vue&type=script&lang=js"
import style0 from "./PackageBuy.vue?vue&type=style&index=0&id=0730c276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730c276",
  null
  
)

export default component.exports